var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-big"},[_c('div',{staticClass:"grid-big"},[_c('TextElement',{attrs:{"headline":"Glossar","isBig":true}})],1),_c('Accordion',{attrs:{"items":_vm.data.items},on:{"link":_vm.onLink}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }